<template lang="pug">
  #app(ref="app")
    stage
    router-view
    header-component
    footer-component
    firebase-interface
    gcp-interface
    web-audio-interface
    swipe-cta-interface(v-if="canShowSwipeCta")
</template>

<script>

import { map, randomInRange } from '@/helpers/MathUtils'
import { mapState, mapMutations } from 'vuex'
import ResizeService from 'src/services/ResizeService'
import HeaderComponent from '@/components/Header'
import FooterComponent from '@/components/Footer'
import Stage from '@/components/Stage' 
import FirebaseInterface from '@/components/firebase/interface' 
import GcpInterface from '@/components/google/interface' 
import WebAudioInterface from '@/components/webaudio/interface' 
import SwipeCtaInterface from '@/components/swipecta/interface'
import SwipeableUIService from '@/services/SwipeableUIService'

export default {

  name: 'app',

  components: {
    HeaderComponent,
    FooterComponent,
    Stage,
    FirebaseInterface,
    GcpInterface,
    WebAudioInterface,
    SwipeCtaInterface
  },

  computed: {
    
    ...mapState('browser', ['isMobile']), 
    ...mapState('app', ['loading']),

    canShowSwipeCta() {
      return (this.isMobile || this.isTablet) && this.$route.name === 'swipeup';
    }
  },

  beforeMount () {
    // listen to resize service and update the store with changes
    ResizeService.on(ResizeService.Events.RESIZE, this.resize)
    this.resize()
  },

  mounted() {

    let ri = randomInRange(0, 3); 
    let goals = [0,  1,  4,  8] 
    this.setTargetIndex(8);
 

    // RIGHT CLICK CONTEXT MENU
    window.addEventListener('contextmenu', (e) => {
      e.preventDefault()
    })
    // window.addEventListener('touchmove', (e) => {
    //   e.preventDefault()
    // }, {
    //   passive: false
    // }) 
  },

  methods: {

    ...mapMutations('question', ['setTargetIndex']),

    ...mapMutations('browser', [
      'setDevice',
      'setScale',
      'setDimensions'
    ]),
    resize () {
      // put these in the store so we don't need to manually
      // listen to ResizeService everytime we want to react to
      // device/scale/size changes
      this.setDevice(ResizeService.device)
      this.setScale(ResizeService.scale)
      this.setDimensions({
        width: ResizeService.width,
        height: ResizeService.height
      })
    }
  },

  watch: {
    'loading.completed'(val){ 
      if(val){ }
    }
  }

}
</script>

<style lang="sass">
@import "src/styles/base.sass"

#app
  +fullFixed()
  background-color: #f8f8f8;
  font-family: 'Courier Prime';
  height: 100vh
</style>
